/** @jsx jsx */
import * as React from 'react';
import { jsx } from "@emotion/core";
import { get } from 'lodash';
import * as styles from './style';
import { IAppState } from '../../../../models/IAppState';
import { connect } from 'react-redux';
import { UserFitnessActions } from '../../../../actions/UserFitnessActions';
import FitnessTemplate from '../../../FitnessPlan/FitnessTemplate/FitnessTemplate';
import OngoingFitnessTemplate from '../OngoingFitnessTemplate';
import AllFitnessPlans from '../../../FitnessPlan/AllFitnessPlans/AllFitnessPlans';
import OngoingAllSavedPlans from '../OngoingAllSavedPlans/OngoingAllSavedPlan';

export enum FitnessTemplateStateType {
    CREATE_PLAN,
    VIEW_PLAN,
    EDIT_PLAN,
    SELECT_TEMPLATE,
    EDIT_FROM_VIEW,
}

interface IFitnessWODEditViewContProps {
    userId: string;
    setUserFitnessPlan: (userPlan: any, startDate: string | number, userProfile: any, isPlanPublished: boolean) => void;
    userProfile: any;
    onBackPress: () => void,
    isOpen: boolean,
    templateType: FitnessTemplateStateType,
    // templateId: number
}

const FitnessWODEditViewCont = (props: IFitnessWODEditViewContProps) => {
    const { userId, userProfile, setUserFitnessPlan, onBackPress, templateType } = props;
    const [selectedTemplateId, setSelectedTemplateId] = React.useState<number>(null);
    const [currentTemplateState, setCurrentTemplateState] = React.useState<FitnessTemplateStateType>(templateType);

    const selectTemplateHandler = () => { }

    const setTemplateIdStateView = (id: number) => {
        setSelectedTemplateId(id);
        setCurrentTemplateState(FitnessTemplateStateType.VIEW_PLAN);

    }

    const setEditFromView = () => {
        //setSelectedTemplateId(null);
        setCurrentTemplateState(FitnessTemplateStateType.EDIT_FROM_VIEW);

    }

    const generateIdsParam = (): { userId?: string, templateId?: number } => {
        // if (selectedTemplateId && currentTemplateState === FitnessTemplateStateType.EDIT_PLAN) return { templateId: selectedTemplateId };
        if (selectedTemplateId) return { templateId: selectedTemplateId };
        return { userId };
    }

    return (
        <React.Fragment>
            <div css={styles.fitnessTemplateWrapperModal} onClick={onBackPress} />
            {currentTemplateState === FitnessTemplateStateType.SELECT_TEMPLATE
                ? <OngoingAllSavedPlans setTemplateId={setTemplateIdStateView} setFitnessPlanState={setCurrentTemplateState} onBackPress={onBackPress} />
                : <div css={styles.body}>
                    <OngoingFitnessTemplate onBackPress={onBackPress} ids={generateIdsParam()} fitnessPlanState={currentTemplateState} onEditFromViewPlan={setEditFromView} />
                </div>}
        </React.Fragment>
    )
}


const mapStateToProps = (state: IAppState, props: any) => ({
    userId: get(state.patientCompleteInfo, "profile.curefitUserId", null),
    userProfile: get(state.patientCompleteInfo, "profile", null),
    coachId: get(state.accountData, "id", null),
    // templateId: get(state.ongoingConsultation.fitnessPlan, "userFitnessPlan.id", null),
    ...props
});

const mapDispatchToProps = (dispatch: React.Dispatch<any>) => ({
    // fetchUserFitnessPlan: (requestParams: IUserFitnessPlanRequestParams) => UserFitnessActions.fetchUserFitnessPlan(requestParams),
    // fetchUserManagedFitnessPlan: (requestParams: IUserFitnessManagedPlanParams) => UserFitnessActions.fetchUserFitnessManagedPlan(requestParams),
    setUserFitnessPlan: (userPlan: any, startDate: string | number, userProfile: any, isPlanPublished: boolean) => UserFitnessActions.setUserFitnessPlan(userPlan, startDate, userProfile, isPlanPublished, dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FitnessWODEditViewCont);


